import { useMutation } from '@tanstack/react-query'
import { MasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'

type Params = {
  masterUuid: string
  jobUuid: string
}

export const useMutationGenerateMasterBatchJobErrorDetailDownloadUrl = () => {
  return useMutation({
    mutationFn: async ({ masterUuid, jobUuid }: Params) => {
      return await baseClient
        .getApi(MasterApi)
        .generateMasterBatchJobErrorDetailDownloadUrl({ masterUuid, jobUuid })
        .catch(handleHTTPError)
    },
  })
}
